import { useState } from "react";
import { C } from "../../../constants/theme";
import { Btn } from "../../ui/Btn";

const TIPOS = [
  { id: "fixo", label: "Fixo (R$)" },
  { id: "por_unidade", label: "Por unidade" },
  { id: "percentual", label: "% do custo" },
];

/* Lista livre de custos extras (embalagem, cola, pintura, transporte,
   desperdício...) — diferente de "Materiais extras", não tem estoque
   próprio, é só um valor pontual pra esse cálculo. */
export function CustosAdicionaisSecao({ itens, adicionar, remover }) {
  const [nome, setNome] = useState("");
  const [tipo, setTipo] = useState("fixo");
  const [valor, setValor] = useState("");
  const [quantidade, setQuantidade] = useState("1");

  const confirmar = () => {
    if (!nome.trim() || !(parseFloat(valor) > 0)) return;
    adicionar({ nome: nome.trim(), tipo, valor, quantidade });
    setNome(""); setValor(""); setQuantidade("1");
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "flex-end" }}>
        <div style={{ flex: "1 1 140px" }}>
          <input value={nome} onChange={e => setNome(e.target.value)} placeholder="Ex: Embalagem"
            style={{ width: "100%", boxSizing: "border-box", background: C.panel, border: "1px solid " + C.border, borderRadius: 8, color: C.text, padding: "8px 12px", fontSize: 13, outline: "none" }} />
        </div>
        <select value={tipo} onChange={e => setTipo(e.target.value)}
          style={{ background: C.panel, border: "1px solid " + C.border, borderRadius: 8, color: C.text, padding: "8px 10px", fontSize: 12, outline: "none" }}>
          {TIPOS.map(t => <option key={t.id} value={t.id}>{t.label}</option>)}
        </select>
        <input type="number" value={valor} onChange={e => setValor(e.target.value)} placeholder={tipo === "percentual" ? "%" : "R$"}
          style={{ width: 76, background: C.panel, border: "1px solid " + C.border, borderRadius: 8, color: C.text, padding: "8px 10px", fontSize: 13, outline: "none", boxSizing: "border-box" }} />
        {tipo === "por_unidade" && (
          <input type="number" value={quantidade} onChange={e => setQuantidade(e.target.value)} placeholder="qtd"
            style={{ width: 60, background: C.panel, border: "1px solid " + C.border, borderRadius: 8, color: C.text, padding: "8px 10px", fontSize: 13, outline: "none", boxSizing: "border-box" }} />
        )}
        <Btn small color={C.warning} onClick={confirmar}>➕</Btn>
      </div>

      {itens.length === 0 && <div style={{ color: C.muted, fontSize: 12 }}>Nenhum custo adicional ainda.</div>}
      {itens.length > 0 && (
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          {itens.map(item => (
            <div key={item.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", background: C.card, borderRadius: 8, padding: "6px 10px" }}>
              <div style={{ display: "flex", gap: 8, alignItems: "center", flex: 1, minWidth: 0 }}>
                <span style={{ color: C.text, fontWeight: 600, fontSize: 12.5 }}>{item.nome}</span>
                <span style={{ color: C.muted, fontSize: 10.5 }}>
                  {item.tipo === "percentual" ? `${item.valor}% do custo` : item.tipo === "por_unidade" ? `R$${parseFloat(item.valor).toFixed(2)} × ${item.quantidade}` : "fixo"}
                </span>
              </div>
              <button onClick={() => remover(item.id)} style={{ background: "none", border: "none", color: C.danger, cursor: "pointer", fontSize: 14, padding: 0 }}>✕</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
